module.exports = __webpack_public_path__ + "static/media/photo128.356fa5d5.jpg";